import { LocalStorageKey } from "@/modules/local-storage/constants";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";
import { ThemeType } from "@/mds/themes/theme-context";

export const writeThemeType = (value: ThemeType): void => {
  try {
    localStorage.setItem(LocalStorageKey.ThemeType, value);
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[writeThemeType] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};

export const clearThemeType = (): void => {
  try {
    localStorage.removeItem(LocalStorageKey.ThemeType);
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[clearThemeType] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};

export const readThemeType = (): ThemeType | null => {
  try {
    const value = localStorage.getItem(LocalStorageKey.ThemeType);
    if (value === null) {
      return null;
    }

    // Validate that the stored value is a valid ThemeType
    if (value === ThemeType.Harvest || value === ThemeType.HarvestMoon) {
      return value as ThemeType;
    }

    // If invalid value, clear it and return null
    logger.warn({
      message: "[readThemeType] Invalid theme type found in localStorage, clearing it.",
      info: {
        invalidValue: value,
      },
    });
    clearThemeType();
    return null;
  } catch (unknownErr) {
    const err = unknownErr as Error;

    logger.warn({
      message: "[readThemeType] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });

    return null;
  }
};
